import React, { FC } from "react";
import PageHeading from "../Common/PageHeading/PageHeading";
import PageContent from "../Common/PageContent/PageContent";

export const Hireus: FC = () => {
  return (
    <section>
      <PageHeading titleText="Hire us! Our deliverable are of high quality" />
      <PageContent>
        <section />
      </PageContent>
    </section>
  );
};

export default Hireus;
